import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { MacroIconCarouselCardStoryblok } from '../../../../types/storyblok';
import { SplideSlide } from '@splidejs/react-splide';
import { Type } from '../../../../base/Type/Type';
import Markup from '../../../../base/Markup/Markup';
import { StoryblokImage } from '../../../../base/StoryblokImage/StoryblokImage';

export const MacroIconCarouselCard = ({
  image,
  heading,
  description,
}: MacroIconCarouselCardStoryblok) => {
  if (!image && !heading && !description) {
    return null;
  }

  return (
    <SplideSlide>
      <Box as="section" className="flex flex-col" overlayOverBkg>
        <Box as="div" className="mb-10 shrink-0 lg:mb-15">
          <StoryblokImage
            src={image}
            alt=""
            mode="responsive"
            maxWidth={600}
            className="h-36 md:h-52"
            assetClassName="!w-auto"
          />
        </Box>

        <Box as="div" className="max-w-lg">
          <Type as="h3" className="mb-5 font-helvetica text-h3 lg:text-h1">
            {heading}
          </Type>
          <Markup content={description} className="text-p1" />
        </Box>
      </Box>
    </SplideSlide>
  );
};

export default MacroIconCarouselCard;
